import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { withReactLayout } from "../../enhancers";
import { useYamsContext } from "../../hooks";
import { Circle } from "../../react-yandex-maps";
var _PlacemarkCircle = function _PlacemarkCircle(_ref) {
  var geometry = _ref.geometry,
    onClick = _ref.onClick,
    options = _ref.options,
    properties = _ref.properties,
    radius = _ref.radius;
  var _useYamsContext = useYamsContext(),
    scaleToZoom = _useYamsContext.scaleToZoom;
  return /*#__PURE__*/React.createElement(Circle, {
    geometry: [geometry, scaleToZoom(radius)],
    onClick: onClick,
    options: _objectSpread(_objectSpread({}, options), {}, {
      fillColor: '#e6008c',
      strokeColor: '#fff',
      strokeWidth: 4
    }),
    properties: properties,
    "data-t-id": "components-PlacemarkCircle"
  });
};
_PlacemarkCircle.propTypes = process.env.NODE_ENV !== "production" ? {
  geometry: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func,
  options: PropTypes.shape({}),
  properties: PropTypes.shape({}),
  radius: PropTypes.number
} : {};
export var PlacemarkCircle = withReactLayout(_PlacemarkCircle);